import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  yesLabel: z.string().max(60).default("Yes"),
  noLabel: z.string().max(60).default("No"),
});

export const yesNoField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "yes_no",
  label: "Yes / No",
  category: "legal",
  icon: "ToggleLeft",
  configSchema,
  // Stored as a boolean, not the label text, so analytics and exports stay comparable even if a
  // programme relabels the buttons.
  valueSchema: (_config, isRequired) => optionalUnlessRequired(z.boolean(), isRequired),
  defaultConfig: { yesLabel: "Yes", noLabel: "No" },
  supportsProfileBinding: true,
  defaultSearchable: true,
  renderHints: {},
};
